import React, { useEffect, useState } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";

// External components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Translation
import { useTranslation } from "react-i18next";

// APIs
import getDarkWebThreats from "api/darkweb/getDarkWebThreats";

// MUI
import Tooltip from "@mui/material/Tooltip";
import { Icon, IconButton } from "@mui/material";
import { useMaterialUIController } from "context";

const DarkWebMonitoring = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [controller] = useMaterialUIController();
  const { user } = controller;

  const getData = async () => {
    try {
      const { results } = await getDarkWebThreats();
      setData(results);
    } catch (e) {
      console.log("error --->", e);
    }
  };

  const goToDetails = (id) => {
    navigate(`/darkweb/threat/${id}`);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {/* Title */}
      <h2 className="page-title">Dark web</h2>

      {/* Page description */}
      <p style={{ fontSize: "small" }}>{t("darkWeb.page_description")}</p>

      {/* Table */}
      <div className="table_users_list" style={{ marginTop: "25px" }}>
        <table className="table-content" cellSpacing="0" cellPadding="0">
          <thead>
            <tr>
              <th style={{ textAlign: "center" }}>{t("darkWeb.date")}</th>
              <th style={{ textAlign: "center" }}>{t("darkWeb.name")}</th>
              <th style={{ textAlign: "center" }}>{t("darkWeb.description")}</th>
              <th style={{ textAlign: "center" }}>{t("darkWeb.victim_nation")}</th>
              <th style={{ textAlign: "center" }}>{t("darkWeb.attack_type")}</th>
              <th style={{ textAlign: "center" }}>{t("darkWeb.details")}</th>
              <th style={{ textAlign: "center" }}>{t("stealers.status")}</th>
            </tr>
          </thead>
          <tbody>
            {data && data.length > 0
              ? data
                  .filter((t) => !!t)
                  .map((threat) => (
                    <tr key={threat.id}>
                      <td>
                        {moment(threat.occurredAt || threat.announcedAt).format("DD/MM/YYYY")}
                      </td>
                      <td>{threat.threatActor?.name || "N/A"}</td>
                      <td style={{ maxWidth: "300px " }}>{threat.title}</td>
                      <td>{threat.victim?.country || "N/A"}</td>
                      <td>{threat.incidentType}</td>
                      <td>
                        <IconButton
                          onClick={() => {
                            goToDetails(threat.id);
                          }}
                          className="default-button"
                          size="small"
                          disableRipple
                        >
                          {t("details")}
                        </IconButton>
                      </td>
                      <td>
                        {threat.canBeManaged ? (
                          user &&
                          user.id &&
                          threat.managedBy &&
                          threat.managedBy.length > 0 &&
                          threat.managedBy.includes(user.id) ? (
                            <Tooltip title={t("darkWeb.managed")} placement="top">
                              <Icon
                                style={{
                                  marginLeft: "5px",
                                  color: "green",
                                }}
                                fontSize="medium"
                              >
                                check
                              </Icon>
                            </Tooltip>
                          ) : (
                            <Tooltip title={t("darkWeb.not_managed_yet")} placement="top">
                              <Icon
                                style={{
                                  marginLeft: "5px",
                                  color: "red",
                                }}
                                fontSize="medium"
                              >
                                close
                              </Icon>
                            </Tooltip>
                          )
                        ) : (
                          <></>
                        )}
                      </td>
                    </tr>
                  ))
              : null}
          </tbody>
        </table>
      </div>
    </DashboardLayout>
  );
};

export default DarkWebMonitoring;
